import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LoadingService } from '../layout/service/loading.service';


@Injectable()
export class LoadingInterceptor {

  constructor(private service: LoadingService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // emit onStarted event before request execution

    this.service.onStarted(req);
    return next.handle(req).pipe(finalize(() => {
      this.service.onFinished(req);

    })
    );


  }

}
